import { getOmnibusPriceFromAPI, hideOmnibuspriceContainer } from '../../scripts/vendor/omnibus';

if (!window.dAgency) window.dAgency = {};
window.dAgency.initProductCard = async card => {
  if (!card) return;

  const omnibusContainer = card.querySelector('.omnibusprice');
  if (omnibusContainer) {
    const brand = omnibusContainer.dataset.omnibus_brand;
    const variantID = omnibusContainer.dataset.omnibus_id;

    if (brand && variantID) {
      const price = await getOmnibusPriceFromAPI(brand, variantID);
      const productCompareAtPrice = parseInt(omnibusContainer.dataset.compare_at_price) / 100;
      if (!productCompareAtPrice) {
        hideOmnibuspriceContainer(omnibusContainer);
      } else {
        const omnibusValue = omnibusContainer.querySelector('.omnibusprice-value');

        omnibusValue.innerText = window.theme.Currency.formatMoney(price * 100, window.theme.moneyFormat);
        omnibusContainer.classList.remove('hidden');
      }
    }
  }
}

if (document.readyState != "loading") {
  [].forEach.call(document.querySelectorAll('.product-card'), card => {
    window.dAgency.initProductCard(card);
  });
} else {
  document.addEventListener('DOMContentLoaded', () => {
    [].forEach.call(document.querySelectorAll('.product-card'), card => {
      window.dAgency.initProductCard(card);
    });
  });
}
